// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_bNJ","cls2":"Comments-cls2_VnT Comments-cls1_bNJ"};